import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Form, Input } from "antd";
import { useI18n } from "../../../../../contexts";
import { FormValueDifferFromTemplateTag } from "../../..";
import { LearnMoreTag } from "../../../../common";
import { useCookieExpertsModal } from "../../../../../hooks";
const FormContentBlockerFieldTechnicalRules = ()=>{
    const { __, _i } = useI18n();
    const { openDialog: openCookieExperts } = useCookieExpertsModal();
    const [ref, setRef] = useState();
    return /*#__PURE__*/ _jsxs(Form.Item, {
        label: __("URLs / Elements to block"),
        required: true,
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "rules",
                noStyle: true,
                rules: [
                    {
                        required: true,
                        message: __("Please provide at least one URL/element!")
                    }
                ],
                children: /*#__PURE__*/ _jsx(Input.TextArea, {
                    autoSize: {
                        minRows: 3,
                        maxRows: 15
                    }
                })
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: "description",
                ref: setRef,
                children: [
                    /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                        form: "blocker",
                        valueName: "rules",
                        widthOfRef: ref,
                        difference: (oldValue, newValue)=>{
                            const currentRules = oldValue.split("\n");
                            const diff = newValue.split("\n").filter((newRule)=>!currentRules.includes(newRule));
                            return diff.length > 0 ? diff : undefined;
                        },
                        apply: (diff, setFieldsValue, oldValue)=>setFieldsValue({
                                rules: oldValue.split("\n").concat(diff).join("\n")
                            }),
                        newValueText: __("Missing entries:"),
                        renderDiff: (value, diff)=>/*#__PURE__*/ _jsx(Input.TextArea, {
                                value: diff.join("\n"),
                                readOnly: true,
                                autoSize: {
                                    minRows: 3,
                                    maxRows: 15
                                }
                            })
                    }),
                    _i(__("Enter one rule per line to replace content with a content blocker. You can block all available URLs or HTML tags on your website including videos, iframes, scripts, inline scripts and stylesheets. Please use an asterisk ({{code}}*{{/code}}) as a wildcard (placeholder)."), {
                        code: /*#__PURE__*/ _jsx("code", {})
                    }),
                    "\xa0•\xa0",
                    !!openCookieExperts && /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: "button-link",
                        onClick: openCookieExperts,
                        children: __("Can't handle it? Let a Cookie Expert help you!")
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    /*#__PURE__*/ _jsx("br", {}),
                    _i(__('{{strong}}Pro tip:{{/strong}} Look up all available syntaxes like {{code}}div[class*="my-embed"]{{/code}} in our knowledge base to block content perfectly.'), {
                        strong: /*#__PURE__*/ _jsx("strong", {}),
                        code: /*#__PURE__*/ _jsx("code", {})
                    }),
                    ` `,
                    /*#__PURE__*/ _jsx(LearnMoreTag, {
                        url: __("https://devowl.io/knowledge-base/real-cookie-banner-create-individual-content-blocker/")
                    })
                ]
            })
        ]
    });
};
export { FormContentBlockerFieldTechnicalRules };
